module.exports = __webpack_public_path__ + "media/zips/Transparent_By_GP_Black_-logo-e610e2b6fafe0bc75b18ed89a8a8d654.zip";